import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { Form } from 'react-final-form';
import { postUploadToS3 } from '../../util/api';
import { getPassportUploadError } from '../../util/passportUpload';
import css from './UploadPassportModal.module.css';
import { Button, Modal, InlineTextButton } from '../../components';
import FileUploader from '../../containers/ProfileSettingsPage/ProfileSettingsForm/FileUplaoder';

export const UploadPassportModal = props => {
  const {
    user,
    setIsUploadPassportOpen,
    onUpdateProfile,
    isUploadPassportOpen,
    onManageDisableScrolling,
    setIsConfirmModalOpen,
    updateInProgress,
  } = props;

  const profile = user?.attributes?.profile || {};
  const { privateData, publicData } = profile;
  const [submitError, setSubmitError] = useState(null);

  const initialPassport = privateData?.idorpassport || null;

  const onSubmit = async formValues => {
    setSubmitError(null);
    let { idorpassport } = formValues;
    const isNewlyAddedDob = false;
    const isPassportUpdated = true;

    if (idorpassport) {
      try {
        const s3Object = await postUploadToS3(idorpassport);
        idorpassport = s3Object.Key;
        const profile = {
          privateData: {
            idorpassport,
            passportUploaded: true,
            passportUploadedAt: new Date().getTime(),
          },
        };
        const result = await onUpdateProfile({ ...profile, isNewlyAddedDob, isPassportUpdated });

        if (result?.success) {
          setIsUploadPassportOpen(false);
          setIsConfirmModalOpen(true);
        } else {
          setSubmitError({ errorId: 'FileUploader.passportSaveFailed', errorText: null });
        }
      } catch (err) {
        setSubmitError(getPassportUploadError(err));
        return;
      }
    }
  };

  useEffect(() => {
    try {
      onUpdateProfile({
        privateData: { askedForPassportUploadedAt: new Date().getTime() },
      });
    } catch (error) {
      console.error(error);
    }
  }, []);

  const submitErrorMaybe = submitError ? (
    <p className={css.error}>
      {submitError.errorId ? <FormattedMessage id={submitError.errorId} /> : submitError.errorText}
    </p>
  ) : null;

  return (
    <Modal
      id="UploadPassportModal"
      containerClassName={css.uploadPassportModal}
      isOpen={isUploadPassportOpen}
      onClose={() => {
        setIsUploadPassportOpen(false);
      }}
      usePortal
      onManageDisableScrolling={onManageDisableScrolling}
      hideCloseBtn={true}
    >
      <div className={css.content}>
        <h2 className={css.title}>
          <FormattedMessage id="UploadPassportModal.heading" />
        </h2>

        <Form
          onSubmit={onSubmit}
          initialValues={{ idorpassport: initialPassport }}
          render={({ handleSubmit, form, submitting, pristine }) => (
            <form onSubmit={handleSubmit} className={css.form}>
              <div className={css.fieldWrapper}>
                {/* <label htmlFor="idorpassport">
                    <FormattedMessage id="UploadPassportModal.passportLabel" />
                  </label> */}
                <FileUploader
                  form={form}
                  formId="uploadPassportForm"
                  initialValues={{
                    idorpassport: initialPassport,
                    isVerified: !!publicData?.isVerified,
                    passportUploaded: privateData?.passportUploaded,
                  }}
                  isModalUpload={true}
                />
              </div>
              {submitErrorMaybe}
              <div>
                <Button
                  type="submit"
                  disabled={submitting || pristine}
                  inProgress={submitting || updateInProgress}
                  className={css.submitButton}
                >
                  <FormattedMessage id="UploadPassportModal.submitButton" />
                </Button>
                <InlineTextButton
                  className={css.closeButton}
                  type="button"
                  onClick={() => {
                    setIsUploadPassportOpen(false);
                    window.location.reload();
                  }}
                >
                  <FormattedMessage id="UploadPassportModal.doItLater" />
                </InlineTextButton>
              </div>
            </form>
          )}
        />
      </div>
    </Modal>
  );
};
export default UploadPassportModal;
